import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/down _arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-4d79a2cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "install-mask"
}
const _hoisted_2 = { class: "install-mask-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-mask-text" }, "安装中，请稍候...", -1))
const _hoisted_4 = { class: "main-header xn-flex-center" }
const _hoisted_5 = { class: "main-logo xn-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.xinnet.com",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    width: "74",
    height: "20"
  })
], -1))
const _hoisted_7 = { class: "hostInfo" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "当前虚拟主机", -1))
const _hoisted_9 = { class: "host" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"transform":"translateY(-2px)"},
  src: _imports_1
}, null, -1))
const _hoisted_11 = { style: {"width":"478px","margin-left":"16px","margin-bottom":"0px"} }
const _hoisted_12 = { style: {"padding":"14px 0px","margin":"0px 16px","border-bottom":"solid 1px #E9E9E9"} }
const _hoisted_13 = { class: "dropdownItem" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "imgs" }, null, -1))
const _hoisted_15 = {
  class: "text",
  style: {"margin-left":"8px"}
}
const _hoisted_16 = {
  class: "tip",
  style: {"margin-left":"6px"}
}
const _hoisted_17 = {
  key: 0,
  class: "text1"
}
const _hoisted_18 = { class: "textDomains" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "text1"
}
const _hoisted_21 = {
  key: 2,
  class: "tip1"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "host" }
const _hoisted_24 = { class: "main-navbar" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://support.xinnet.com/#/submit",
  target: "_blank"
}, "提交工单", -1))
const _hoisted_26 = {
  key: 0,
  class: "link",
  href: "https://tas.xinnet.com/#/service/icpManager",
  target: "_blank"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://www.xinnet.com/service/service.html",
  target: "_blank"
}, " 帮助文档 ", -1))
const _hoisted_28 = {
  class: "xn-pointer",
  id: "taskMsg"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务消息", -1))
const _hoisted_30 = { class: "main-menu" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px"} }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "s2-ml" }, "首页", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bhr" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"4px"} }, null, -1))
const _hoisted_35 = { class: "main-content" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 镜像安装完成,是否需要自动配置主机环境？ ", -1))
const _hoisted_37 = { class: "xn-footer" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 此操作将会清空当前主机所有配置使用镜像配置覆盖，是否继续？ ", -1))
const _hoisted_39 = { class: "xn-footer" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.配置中,请勿离开,离开可能导致配置失败", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2.配置失败项请前往主机环境配置手动配置", -1))
const _hoisted_42 = { class: "progress-container" }
const _hoisted_43 = { class: "progress-text" }
const _hoisted_44 = { class: "progress-title" }

import { provide, computed, ref, h, resolveComponent, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from "vue-router"
import { CaretDownOutlined, SearchOutlined, CheckCircleTwoTone, CloseCircleTwoTone} from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import Tasks from './tasks.vue'
import Menus from './menus.vue'
import { logout, getAllHostList, getLoginSource, changeHost, updateTaskStatus } from '@/api/main'
import { queryTaskList, updateTask, getCloneInfo } from '@/api/task'
import Detail from '@/views/taskCenter/detail.vue'
import { queryTaskPage } from '@/api/task'
import { setDefaultHomePage,setRedirectConfig,setErrorPage,setDotnetScriptError,addMimeConfig,setPhpLang,setPhpChangeVersion,updatePhpParam,setPhpErrorLog,setPhpOb,setPhpUpload,setPhpMaxUploadSize,setPhpDisableFuncs,setDotnetTrustedLevel,setDotnetChangeVersion,clearConfig } from '@/api/home'
import { rewriteSet } from '@/api/pseudoStatic'

const day = 1000 * 60 *60 * 24

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const menus = ref()
const collapsed = ref(false)
const openKeys: any = ref([])
const selectedKeys: any = ref([])
const isHome = ref(false)
const count = ref(0)
const runningTask = ref('')
const notifyClose = ref()
const notifyCode = ref('')
const showTasks = computed(() => {
  return store.state.tempTask.showTasks
})

const showList = ref(false)
const searchType = ref<string>('hostName');
const searchValue = ref<string>('');
const settingShow = ref(true)


const scrollContainer = ref<HTMLElement | null>(null)
let isLocked = false // 防止重复触发

const handleScroll = () => {
  checkScroll()
}

// 添加加载状态和防抖
const isLoading = ref(false);
const hasMore = ref(true);
let lastScrollTime = 0;
const pageCount = ref(0);

const checkScroll = () => {
  // 获取真实的滚动容器DOM
  const scrollContainerEl = scrollContainer.value?.$el;
  if (!scrollContainerEl) return;
  const { scrollTop, scrollHeight, clientHeight } = scrollContainerEl;
  const isNearBottom = scrollHeight - (scrollTop + clientHeight) <= 100;

  const now = Date.now();
  // console.log(pageCount.value,'pageCount.value',isLoading.value,'isLoading.value',now - lastScrollTime,'now - lastScrollTime')
  // console.log(isNearBottom && hasMore.value && !isLoading.value && (now - lastScrollTime > 300))
  
  if (isNearBottom && hasMore.value && !isLoading.value && (now - lastScrollTime > 300)) {
    isLoading.value = true;
    lastScrollTime = now;
    pagesMax.value == pageIndex.value ?  pageIndex.value = pagesMax.value : pageIndex.value += 1
    // console.log(pagesMax.value,'pagesMax')
    // console.log('加载更多',count)
    if(pageCount.value < 1){
      getAllHostList(pageIndex.value,pageSize.value,{[searchType.value]:searchValue.value}).then((res:any) => {
        if(res.code === '200'){
          hostList.value = [...hostList.value,...res.res?.hostList?.records]
          isLoading.value = false;
        }
      })
    }
    if(pageIndex.value == pagesMax.value){
      // console.log('没有更多数据了',count)
      pageCount.value = 1
    }
    
  }
};


const changeHostHandel = (item) => {
  if(LoginSource.value == 'HOST_TOKEN'){
    let params = new FormData()
    params.append('hostCode', item.hostCode)
    changeHost(params).then(res => {
      if(res.code == '200'){
        window.location.reload()
      }
    })
  }
  
}

const menuList = computed(() => {
  return store.state.menuList
})

const triggerTasks = (val) => {
  store.commit('tempTask/triggerTask', val)
}

const goHome = () => {
  router.push('/')
  selectedKeys.value = []
}

const handleCollapse = () => {
  collapsed.value = !collapsed.value
}

const flattenData = (list: any, _result?) => {
  const result: any = _result || []
  list.forEach(({ children, ...rest }) => {
    result.push(rest)
    if (children?.length) {
      flattenData(children, result)
    }
  })
  return result
}

const handleLogout = async () => {
  try {
    const res: any = await logout()
    window.location.reload()
    Xinnet.message.success(res.msg)
  } catch(e) {
    console.error('登出失败！')
  }
}

const hostList:any = ref([])
const pageIndex = ref(1)
const pageSize = ref(10)
const pagesMax = ref(0)
const getListHandel = () => {
  hostList.value = []
  pageCount.value = 0
  pageIndex.value = 1
  isLoading.value = false;
  getAllHostList(pageIndex.value,pageSize.value,{[searchType.value]:searchValue.value}).then((res:any) => {
    if(res.code === '200'){
      hostList.value = res.res?.hostList?.records || []
      pagesMax.value = res.res?.hostList?.pages || 0
    }
  })
}

watch(route, (curRoute) => {
  try {
    if (curRoute.matched?.length && store.state.menuList?.length) {
      const items = curRoute.matched.slice(0, -1)
      const list = flattenData(store.state.menuList)
      // openKeys.value = items.reduce((r: any, o) => {
      //   const exist: any = list.find(c => c.path === o.path)
      //   if (exist) {
      //     r.push(exist.key)
      //   }
      //   return r
      // }, [])
      // 默认全部展开菜单
      openKeys.value = list.map(o => o.key)
      // 已选中菜单
      const selectedItem = list.find((o) => {
        return o.path === curRoute.matched.at(-1)?.path
      })
      if (selectedItem) {
        selectedKeys.value = [selectedItem.key]
      }

      // 选中首页
      if (!openKeys.value?.length && !selectedKeys.value?.length) {
        isHome.value = true
      } else {
        isHome.value = curRoute.path === '/'
      }
    }
    if (curRoute.path === '/') {
      selectedKeys.value = []
    }
  } catch(e) {
    console.error('解析openKeys失败！')
  }
}, { immediate: true })

const menuClick = (e) => {
  const list = flattenData(store.state.menuList)
  const item = list.find(o => o.key === e.key)
  item && router.push(item.path)
}

// 获取网站搬家数据
const getSite = async (taskCode, t) => {
  const res: any = await getCloneInfo(taskCode)
  t.file = res?.res || {}
  if (t.file?.copiedBytes) {
    t.file.copiedBytes = Xinnet.util.fileDiskSize(t.file.copiedBytes, 2)
  }
}


// 查看任务详情
const open = ref<boolean>(false)
const curRow = ref<any>({})

const onClose = () => open.value = false

const previewDetail = (row) => {
  curRow.value = row
  open.value = true
}


const ticktock: any = ref(0)
const _tasks = ref<any[]>([])
const tasks = ref<any[]>([])
const [api, contextHolder] = notification.useNotification()

const getTasks = (hostCode, init = false) => {
  queryTaskList({ hostCode }).then((res: any) => {
    _tasks.value = tasks.value = res.res?.map((o) => {
      // 解决任务盒子-网站搬家闪动BUG
      if (o.taskType === 'SITE_MOVE') {
        o.file = tasks.value.find((t) => o.id === t.id)?.file
      }
      return o
    }) || []
    // 有未完成的文件类任务，不创建临时任务（临时任务属于文件类任务，只能有一个运行中的）
    const runningFileTask = tasks.value.find((o) => {
      return o.taskType !== 'DB_BACKUP' && ['RUNNING', 'WAIT'].includes(o.taskStatus)
    })
    if (runningFileTask) {
      store.commit('tempTask/setLocked', true)
    } else {
      store.commit('tempTask/setLocked', false)
    }
    tasks.value = tasks.value.slice(0, 5)
    if (store.state.tempTask.taskList?.[0]?.fileList?.length) {
      addTempTask(store.state.tempTask.taskList)
    }
    let num = 0
    tasks.value?.forEach((t) => {
      if(t.taskStatus == 'RUNNING' || t.taskStatus == 'WAIT') {
        num += 1
        if(num == 1 && runningTask.value != t.id) {
          runningTask.value = t.id
          runningNotify(t)
        }
      }
      // 一天内已完成（成功|失败）的任务，非临时任务轮训通知
      if (!['UPLOAD_FILE', 'COMPRESS', 'DECOMPRESS'].includes(t.taskType)) {
        const inHour24 = (+new Date() - +new Date(t.createTime)) <= day
        if (
          ['RUNNING_SUCCESS', 'RUNNING_FAIL'].includes(t.taskStatus)
          && t.notifyStatus === 0 && inHour24
        ) {
          notify(t)
        }
        // 已完成未读任务修改状态
        if (t.notifyStatus === 0) {
          updateTask(t.id)
        }
        // 获取网站搬家数据
        if (t.taskType === 'SITE_MOVE' && t.preTaskCode) {
          getSite(t.preTaskCode, t)
          if(t.taskStatus == 'WAIT' || t.taskStatus == 'RUNNING') {
            if(num == 1) {
              runningTask.value = t.id
              runningNotify(t)
            }
          }
        }
      }
    })
    count.value = num
  })

  if (init) {
    clearTimeout(ticktock.value)
    ticktock.value = setTimeout(() => {
      getTasks(hostCode, init)
    }, 5000)
  }
}

const taskInfos = ref('1223')
const taskCloseId = ref()
const runningNotify = (t) => {
  api.destroy(notifyCode.value)
  
  const type = Xinnet.settings.taskTypeOpts.find((o) => o.value === t.taskType)?.text
  const state = Xinnet.settings.taskStatusOpts.find((o) => o.value === t.taskStatus)?.text
  const description = `${type}任务${state}`
  taskInfos.value = getRunningDesc(t.taskType, t)
  
  if(taskCloseId.value != runningTask.value) {
    notifyClose.value = api.info({
      message: description,
      placement: 'bottomLeft',
      duration: 6000,
      key: t.id,
      onClose: () => {
        taskCloseId.value = t.id
      },
      description: () => {
        return taskInfos.value
      },
      icon: () => {
        const type = 'primary'
        return h(
          resolveComponent('xn-icon'),
          {
            icon: `alert_${type}`,
            class: 'icon',
            style: { height: '24px', width: '24px' }
          }
        )
      }
    })
    notifyCode.value = t.id
  }
}

const getRunningDesc = (type, task) => {
  if (type === 'UPLOAD_FILE') {
    return `已上传${task.uploaded}个文件${task.size ? `（${task.size}）` : ''}，${task.failed ? '失败'+ task.failed +'个，' : ''}剩余${task.uploading}个文件，正在上传第${task.whichFile}个文件进度${task.ratio}%`
  }
  if (type === 'SITE_MOVE') {
    let curFile = ''
    if (task.file?.processing) {
      curFile = extractLastSlash(task.file.processing)
    }
    return `已搬运${task.file?.copiedFiles || 0}个文件${task.file?.copiedBytes ? `（${task.file.copiedBytes}）` : ''}，正在传输${curFile}`
  }
  if (type === 'DECOMPRESS') {
    const filename = extractLastSlash(task.filename)
    return `正在解压 ${filename} ${task.processed}/${task.total}`
  }
  if (type === 'COMPRESS') {
    if (task.progress) {
      return `正在下载，进度${task.progress}%`
    }
    if (task.downloaded) {
      return `正在下载，已下载${task.downloaded}，下载速度${task.rate}`
    }
    return '正在下载'
  }
  if (type === 'APP_INSTALL') {
    try {
      return `正在安装 ${JSON.parse(task.taskParam)?.appName}`
    } catch(e) {
      return ''
    }
  }
  if (type === 'WEB_BACKUP') return '正在备份'
  if (type === 'DB_BACKUP') return '正在备份'
  if (type === 'WEB_BACKUP_RESTORE') return '正在恢复'
}


const extractLastSlash = (str) => {
  let res = ''
  if (str) {
    const lastIndex = str.lastIndexOf('/')
    res = str.substring(lastIndex + 1)
  }
  return res
}

// 通知
const notify = (t) => {
  if(t.id == runningTask.value) {
    api.destroy()
  }
  const type = Xinnet.settings.taskTypeOpts.find((o) => o.value === t.taskType)?.text
  const state = Xinnet.settings.taskStatusOpts.find((o) => o.value === t.taskStatus)?.text
  const description = `${type}任务${state}`
  const isFailed = t.taskStatus === 'RUNNING_FAIL'
  const message = isFailed ? '任务失败' : '任务完成'
  api.info({
    message: message,
    placement: 'bottomLeft',
    description: () => {
      if (isFailed) {
        return h(
          'div',
          [
            h(
              'span',
              {
                style: {
                  'display': 'inline-block',
                  'paddingRight': '20px',
                  'width': 'calc(100% - 60px)',
                }
              },
              description
            ),
            h(
              'span',
              { style: { 'textAlign': 'right', 'width': '60px' }},
              [
                h(
                  'span',
                  {
                    class: 'xn-link xn-pointer s3-mt',
                    onClick: () => previewDetail(t)
                  },
                  '任务详情'
                )
              ]
            )
          ]
        )
      }
      return description
    },
    icon: () => {
      const type = isFailed ? 'danger' : 'success'
      return h(
        resolveComponent('xn-icon'),
        {
          icon: `alert_${type}`,
          class: 'icon',
          style: { height: '24px', width: '24px' }
        }
      )
    }
  })
}

const currentHost = ref('')
const LoginSource = ref('')
onMounted(() => {
  clearTimeout(ticktock.value)
  // console.log(route,route.meta,route.path,'route')
  if(window.location.hash.indexOf('login') == -1){
    getAllHostList(pageIndex.value,pageSize.value,{}).then((res:any) => {
      if(res.code === '200'){
        currentHost.value = res.res?.currentHostName || ''
      }
    })
    getLoginSource().then((res:any) => {
      if(res.code === '200'){
        LoginSource.value = res.res
        // console.log(res.res,'getLoginSource')
        // store.commit('hostInfo/setHostService', res.res)
      }
    })
  }
  if(store.state.hostInfo?.specInfo?.language?.includes('NET')) {
    progressList.value.push({ icon: 'wordpress', title: '设置脚本错误信息', percent: 100, status: 'normal' })
    progressList.value.push({ icon: 'wordpress', title: '.NET设置', percent: 100, status: 'normal' })
  }
 
})

const hasRunning = ref(false)
const configAuto = ref(false)
let taskTimer: any = null
const currentConfigImageConfig:any = ref('')
const currentConfigTaskId:any = ref('')

const queryTaskPageHandel = (hostCode) => {
  queryTaskPage({ hostCode, current: 1, pageSize: 20 }, { taskType: "APP_INSTALL" }).then((res: any) => {
    hasRunning.value = Array.isArray(res.res.elements) && res.res.elements.some(item => item.taskStatus === 'RUNNING');
    // 查找第一个postStatus为CONFIGURATION的任务
    const configTask = Array.isArray(res.res.elements) && res.res.elements.find(item => item.postStatus === 'CONFIGURATION');
    configAuto.value = !!configTask;
    if(configAuto.value){
      currentConfigImageConfig.value = JSON.parse(configTask.taskInfo)?.imageConfig;
      currentConfigTaskId.value = configTask.id
      console.log(configTask,'currentConfigTaskInfo.value',currentConfigImageConfig.value)
      store.commit('modal/open', { uid: 'configAuto' })
    }
    if (hasRunning.value) {
      taskTimer = setTimeout(() => queryTaskPageHandel(hostCode), 5000)
    } else {
      if (taskTimer) {
        clearTimeout(taskTimer)
        taskTimer = null
      }
    }
  })
}

// 调用 updateTaskStatus 时传递 taskId
const toCancel = ()=> {
  localStorage.removeItem('hasReloaded');
  console.log(currentConfigTaskId.value)
  updateTaskStatus(currentConfigTaskId.value,{postStatus:'CONFIGURATION_STOP'}).then(res=>{
    store.commit('modal/close')
  })
}

// const toClearCancel = () => {
//   store.commit('modal/close')
// }

const tohandleConfirm = () => {
   store.commit('modal/close',{uid:'configAuto'})
  store.commit('modal/open',{uid:'isSubmit'})
}

const toConfirms = () => {
  clearConfig().then((res) => {
    if(res.code == '200') {
      toConfirm()
    }
  })
}

const toConfirm = async () => {
  store.commit('modal/close', {uid: 'isSubmit'})
  store.commit('modal/open', { uid: 'configuration' })

  // 1. 设置网站首页
  progressList.value[0].percent = 0
  progressList.value[0].status = 'normal'
  const homePromise = setDefaultHomePage({ docs: currentConfigImageConfig.value.indexPath })
    .then(() => {
      progressList.value[0].percent = 100
      progressList.value[0].status = 'success'
    })
    .catch(() => {
      progressList.value[0].percent = 100
      progressList.value[0].status = 'exception'
    })

  // 2. 设置伪静态
  progressList.value[1].percent = 0
  progressList.value[1].status = 'normal'
  let rewritePromise = Promise.resolve()
  if(currentConfigImageConfig.value.rewriteCode == '' || !currentConfigImageConfig.value.rewriteCode) {
    progressList.value[1].percent = 100
    progressList.value[1].status = 'success'
  } else {
    rewritePromise = rewriteSet(currentConfigImageConfig.value.rewriteCode)
    .then(() => {
      progressList.value[1].percent = 100
      progressList.value[1].status = 'success'
    })
    .catch(() => {
      progressList.value[1].percent = 100
      progressList.value[1].status = 'exception'
    })
  }

  // 3. 添加301重定向
  progressList.value[2].percent = 0
  progressList.value[2].status = 'normal'
  const redirectList = currentConfigImageConfig.value.redirectDomain || []
  let redirectPromise
  if (redirectList.length === 0) {
    progressList.value[2].percent = 100
    progressList.value[2].status = 'success'
    redirectPromise = Promise.resolve()
  } else {
    redirectPromise = Promise.all(
      redirectList.map(item =>
        setRedirectConfig({ source: item.split('|')[0], target: item.split('|')[1] })
      )
    ).then(() => {
      progressList.value[2].percent = 100
      progressList.value[2].status = 'success'
    }).catch(() => {
      progressList.value[2].percent = 100
      progressList.value[2].status = 'exception'
    })
  }

  // 4. 设置404页面
  progressList.value[3].percent = 0
  progressList.value[3].status = 'normal'
  let errorPagePromise
  if(currentConfigImageConfig.value.errorPage == '') {
    progressList.value[3].percent = 100
    progressList.value[3].status = 'success'
    errorPagePromise = Promise.resolve()
  } else {
    errorPagePromise = setErrorPage({ path: currentConfigImageConfig.value.errorPage })
      .then(() => {
        progressList.value[3].percent = 100
        progressList.value[3].status = 'success'
      })
      .catch(() => {
        progressList.value[3].percent = 100
        progressList.value[3].status = 'exception'
      })
  }

  // 5. 添加MIME 映射
  progressList.value[4].percent = 0
  progressList.value[4].status = 'normal'
  const mimeList = currentConfigImageConfig.value.mime || []
  let mimePromise
  if (mimeList.length === 0) {
    progressList.value[4].percent = 100
    progressList.value[4].status = 'success'
    mimePromise = Promise.resolve()
  } else {
    mimePromise = Promise.all(
      mimeList.map(mimeItem =>
        addMimeConfig({
          extension: mimeItem.split('|')[1],
          mineType: mimeItem.split('|')[0]
        })
      )
    ).then(() => {
      progressList.value[4].percent = 100
      progressList.value[4].status = 'success'
    }).catch(() => {
      progressList.value[4].percent = 100
      progressList.value[4].status = 'exception'
    })
  }

  // 6. PHP设置
  progressList.value[5].percent = 0
  progressList.value[5].status = 'normal'
  
  let phpLangPromise
  if(store.state.hostInfo?.specInfo?.language?.includes('NET')) {
    phpLangPromise = setPhpLang(currentConfigImageConfig.value.phpVersion, currentConfigImageConfig.value.phpSwitch.code)
  } else {
    phpLangPromise = Promise.resolve()
  }
  const phpChangePromise = setPhpChangeVersion(currentConfigImageConfig.value.phpVersion)
  const phpShortOpenTagPromise = updatePhpParam({
    phpIniKey: "short_open_tag",
    phpIniValue: currentConfigImageConfig.value.phpShortOpenTag.code
  })
  const phpDisplayErrorsPromise = updatePhpParam({
    phpIniKey: "display_errors",
    phpIniValue: currentConfigImageConfig.value.phpDisplayErrors.code
  })
  const phpErrorLogPromise = setPhpErrorLog(currentConfigImageConfig.value.phpErrLogSwitch.code)
  const phpObSwitchPromise = setPhpOb(currentConfigImageConfig.value.phpOBSwitch.code)
  const phpSetphpUploadSwitchPromise = setPhpUpload(currentConfigImageConfig.value.phpUploadSwitch.code)
  const phpMaxPhpUploadSizePromise = setPhpMaxUploadSize(currentConfigImageConfig.value.maxPhpUploadSize)
  const phpMaxInputTimePromise = updatePhpParam({
    phpIniKey: 'max_input_time',
    phpIniValue: currentConfigImageConfig.value.phpMaxInputTime,
  })
  const phpMaxFileUploadsPromise = updatePhpParam({
    phpIniKey: 'max_file_uploads',
    phpIniValue: currentConfigImageConfig.value.phpMaxFileUploads
  })
  const phpDataTimeZonePromise = updatePhpParam({
    phpIniKey: 'date.timezone',
    phpIniValue: currentConfigImageConfig.value.phpDateTimezone
  })
  const phpErrorReportingPromise = updatePhpParam({
    phpIniKey: 'error_reporting',
    phpIniValue: currentConfigImageConfig.value.phpErrorReporting.join(',')
  })
  const chown = currentConfigImageConfig.value.disabledFuncs?.includes('chown') ? 'OFF' : 'ON'
  const fsockopen = currentConfigImageConfig.value.disabledFuncs?.includes('fsockopen') ? 'OFF' : 'ON'
  const assert = currentConfigImageConfig.value.disabledFuncs?.includes('assert') ? 'OFF' : 'ON'
  let param = ''
  if (chown === 'OFF' && fsockopen === 'OFF' && assert === 'OFF') {
    param = 'chown,fsockopen,assert'
  } else if (chown === 'OFF' && fsockopen === 'OFF') {
    param = 'chown,fsockopen'
  } else if (fsockopen === 'OFF' && assert === 'OFF') {
    param = 'fsockopen,assert'
  } else if (chown === 'OFF' && assert === 'OFF') {
    param = 'chown,assert'
  } else if (chown === 'OFF') {
    param = 'chown'
  } else if (fsockopen === 'OFF') {
    param = 'fsockopen'
  } else if (assert === 'OFF') {
    param = 'assert'
  } else {
    param = 'none'
  }
  const phpsetPhpDisableFuncsPromise = setPhpDisableFuncs(param)
 
  const phpPromise = Promise.all([
    phpLangPromise,
    phpChangePromise,
    phpShortOpenTagPromise,
    phpDisplayErrorsPromise,
    phpErrorLogPromise,
    phpObSwitchPromise,
    phpSetphpUploadSwitchPromise,
    phpMaxPhpUploadSizePromise,
    phpMaxInputTimePromise,
    phpMaxFileUploadsPromise,
    phpDataTimeZonePromise,
    phpErrorReportingPromise,
    phpsetPhpDisableFuncsPromise,
  ]).then(() => {
    progressList.value[5].percent = 100
    progressList.value[5].status = 'success'
  }).catch(() => {
    progressList.value[5].percent = 100
    progressList.value[5].status = 'exception'
  })

  let scriptErrorPromise
  if(progressList.value[6]?.title == '设置脚本错误信息') {
    // 7. 设置脚本错误信息有net信息添加/specInfo?.language?.includes('NET')
    progressList.value[6].percent = 0
    progressList.value[6].status = 'normal'
    scriptErrorPromise = setDotnetScriptError({
      notify: currentConfigImageConfig.value.scriptError[0],
      msg: currentConfigImageConfig.value.scriptError[1]
    }).then(() => {
      progressList.value[6].percent = 100
      progressList.value[6].status = 'success'
    }).catch(() => {
      progressList.value[6].percent = 100
      progressList.value[6].status = 'exception'
    })
  } else {
    scriptErrorPromise = Promise.resolve()
  }

  // 判断是否有net/specInfo?.language?.includes('NET')
  let dotnetPromise = Promise.resolve()
  if(progressList.value[7]?.title == '.NET设置') {
    // 8. .NET设置
    progressList.value[7].percent = 0
    progressList.value[7].status = 'normal'
    const phpSetDotnetTrustedLevelPromise = setDotnetTrustedLevel(currentConfigImageConfig.value.dotNetTrustedLevel)
    const phpSetDotnetChangeVersionPromise = setDotnetChangeVersion(currentConfigImageConfig.value.dotnetVersion, currentConfigImageConfig.value.dotnetMode)
    dotnetPromise = Promise.all([
      phpSetDotnetTrustedLevelPromise,
      phpSetDotnetChangeVersionPromise,
    ]).then(() => {
      progressList.value[7].percent = 100
      progressList.value[7].status = 'success'
    }).catch(() => {
      progressList.value[7].percent = 100
      progressList.value[7].status = 'exception'
    })
  }

  // 汇总所有Promise
  const allPromise = Promise.all([
    homePromise,
    rewritePromise,
    redirectPromise,
    errorPagePromise,
    scriptErrorPromise,
    mimePromise,
    phpPromise,
    dotnetPromise
  ])

  // 判断全部成功或有失败
  allPromise.then(() => {
    settingShow.value = false
    updateTaskStatus(currentConfigTaskId.value, { postStatus: 'CONFIGURATION_SUCCESS' })
  }).catch(() => {
    settingShow.value = false
    updateTaskStatus(currentConfigTaskId.value, { postStatus: 'CONFIGURATION_STOP' })
  })
}

const progressList = ref([
        { icon: 'cloud-upload', title: '设置网站首页', percent: 100, status: 'normal' },
        { icon: 'database', title: '设置伪静态', percent: 100, status: 'normal' },
        { icon: 'server', title: '添加301重定向', percent: 100, status: 'normal' },
        { icon: 'wordpress', title: '设置404页面', percent: 100, status: 'normal' },
        // { icon: 'wordpress', title: '设置脚本错误信息', percent: 100, status: 'normal' },
        { icon: 'wordpress', title: '添加MIME 映射', percent: 100, status: 'normal' },
        { icon: 'wordpress', title: 'PHP设置', percent: 100, status: 'normal' },
        // { icon: 'wordpress', title: '.NET设置', percent: 100, status: 'normal' }
      ])

// 添加临时任务到任务队列
const addTempTask = (taskList) => {
  if (taskList?.length) {
    // 文件转换为临时任务
    const tempTasks = taskList.map((task) => {
      const {
        id, loading, progress, createTime, endTime, filename, whichFile,
        size, totalSize, cancel, fileList, taskType, ratio, notifyStatus,
        downloaded, rate, taskStatus, taskInfo
      } = task
      const res: any = {
        id,
        createTime,
        endTime,
        size,
        totalSize,
        taskStatus: 'RUNNING',
        taskType,
        filename,
        // 任务进度
        progress,
        notifyStatus,
        total: fileList.length,
      }

      if (taskType === 'COMPRESS') {
        rate && (res.rate = rate)
        downloaded && (res.downloaded = downloaded)
      }
      if (taskType === 'DECOMPRESS') {
        res.total = task.total
        res.processed = task.processed
        if (taskStatus) {
          res.taskInfo = taskInfo
          res.taskStatus = taskStatus
        }
      }
      if (taskType === 'UPLOAD_FILE') {
        res.failed = fileList.filter((o) => o.failed).length
        res.succeed = fileList.filter((o) => (o.done && !o.failed)).length
        res.uploaded = fileList.filter((o) => o.done).length
        res.uploading = fileList.filter((o) => !o.done).length
        // 上传文件百分比
        res.ratio = ratio
        res.whichFile = whichFile
        if (fileList.find((o) => o.failed)) {
          res.taskStatus = 'RUNNING_FAIL'
        }
      }
      if (cancel) {
        res.taskStatus = 'STOP'
      }
      if (loading === false) {
        res.endTime = Xinnet.util.formatTime(new Date())
        if (!fileList.find((o) => o.failed)) {
          res.taskStatus = 'RUNNING_SUCCESS'
        }
      }

      // 已完成的未读临时任务，立即通知
      if (notifyStatus === 0 && ['RUNNING_SUCCESS', 'RUNNING_FAIL'].includes(res.taskStatus)) {
        notify(res)
        store.commit('tempTask/updateTaskState', { task: res, value: 1 })
      }
      return res
    })
    tasks.value = [...tempTasks, ..._tasks.value].slice(0, 5)
    let num = 0
    tasks.value?.forEach((t) => {
      if(t.taskStatus == 'RUNNING' || t.taskStatus == 'WAIT') {
        num += 1
      }
      if(runningTask.value == t.id && t.taskType != 'DB_BACKUP' && (t.taskStatus == 'RUNNING' || t.taskStatus == 'WAIT')) {
        runningNotify(t)
      }
    })
    count.value = num
  }
}

const notifyTasks = () => {
  const { hostService } = store.state.hostInfo
  if (hostService?.hostCode) {
    getTasks(hostService.hostCode, false)
    // store.commit('tempTask/triggerTask', true)
  }
}




watch(() => store.state.tempTask.taskList, (taskList) => {
  if (taskList?.[0]?.fileList?.length) {
    addTempTask(taskList)
  }
  // 有未完成临时任务
  if (taskList?.[0]?.fileList?.find((o) => !o.done)) {
    Xinnet.taskRunning = true
  } else {
    Xinnet.taskRunning = false
  }
}, { deep: true, immediate: true })

watch(() => store.state.hostInfo, (host) => {
  if (host?.hostService?.hostCode) {
    queryTaskPageHandel(host.hostService.hostCode)
    getTasks(host.hostService.hostCode, true)
  }
}, { deep: true, immediate: true })



provide('getTasks', notifyTasks)

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_xn_icon = _resolveComponent("xn-icon")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_xn_modal = _resolveComponent("xn-modal")!
  const _component_xn_alert = _resolveComponent("xn-alert")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (hasRunning.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_spin, { size: "large" }),
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { style: {position: 'fixed', zIndex: 13, width: '100%'} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (LoginSource.value == 'HOST_TOKEN')
                    ? (_openBlock(), _createBlock(_component_a_dropdown, {
                        key: 0,
                        class: "hostInfoDropdown",
                        visible: showList.value,
                        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showList).value = $event)),
                        style: {"width":"478px"},
                        trigger: "click",
                        onClick: getListHandel
                      }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, {
                            virtual: false,
                            class: "header-list",
                            style: {"width":"478px","padding":"16px","max-height":"354px","overflow":"hidden","box-shadow":"0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 6px -4px rgba(0,0,0,0.12)","border-radius":"8px","margin-top":"2px","padding-left":"0","padding-right":"0"},
                            ref_key: "scrollContainer",
                            ref: scrollContainer
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_a_input_group, { compact: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select, {
                                      style: {"width":"120px"},
                                      value: searchType.value,
                                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchType).value = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select_option, { value: "hostName" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("站点名/备注")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_select_option, { value: "domain" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("域名")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"]),
                                    _createVNode(_component_a_input, {
                                      value: searchValue.value,
                                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchValue).value = $event)),
                                      placeholder: searchType.value === 'hostName' ?  '请输入站点名或备注(模糊搜索)' : '请输入域名(模糊搜索)',
                                      style: {"width":"323px"},
                                      onChange: getListHandel
                                    }, {
                                      suffix: _withCtx(() => [
                                        _createVNode(_unref(SearchOutlined), { style: {"color":"rgba(0, 0, 0, 0.25)"} })
                                      ]),
                                      _: 1
                                    }, 8, ["value", "placeholder"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", {
                                style: {"height":"300px","overflow-y":"auto","overflow-x":"hidden"},
                                onScroll: handleScroll
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hostList.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: item.hostCode,
                                    onClick: ($event: any) => (changeHostHandel(item)),
                                    class: _normalizeClass(item.hostName === currentHost.value ? ['dropdownItems  dropdownItemsActive'] :  ['dropdownItems'] ),
                                    style: {"padding":"0","border-radius":"0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                          _hoisted_14,
                                          _createElementVNode("span", _hoisted_15, _toDisplayString(item.hostName), 1),
                                          _createElementVNode("span", _hoisted_16, "(" + _toDisplayString(item?.specInfo?.osType) + ")", 1)
                                        ]),
                                        (item.domains && item.domains.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.domains, (itemDomain, ind) => {
                                                return (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                  _createTextVNode(_toDisplayString(itemDomain) + " ", 1),
                                                  (ind !== item.domains.length - 1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "|"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 256))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_20, "暂未绑定域名")),
                                        (item.remark)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.remark), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "class"]))
                                }), 128))
                              ], 32)
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "ant-dropdown-link",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createTextVNode(_toDisplayString(currentHost.value), 1),
                              _hoisted_10
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(currentHost.value), 1)
                      ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                (_ctx.$auth(['USER', 'ADMINISTRATOR']))
                  ? (_openBlock(), _createElementBlock("a", _hoisted_26, "专家服务"))
                  : _createCommentVNode("", true),
                _hoisted_27,
                _createVNode(_component_a_dropdown, {
                  open: showTasks.value,
                  "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((showTasks).value = $event)),
                  class: "s10-mr",
                  arrow: "",
                  placement: "bottom",
                  trigger: "click",
                  onOpenChange: triggerTasks
                }, {
                  overlay: _withCtx(() => [
                    _createVNode(Tasks, {
                      tasks: tasks.value,
                      getTasks: getTasks
                    }, null, 8, ["tasks"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_a_badge, {
                        count: count.value,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["count"]),
                      _createVNode(_unref(CaretDownOutlined), { class: "s2-ml" })
                    ])
                  ]),
                  _: 1
                }, 8, ["open"]),
                _createElementVNode("a", {
                  class: "xn-pointer s6-mr",
                  style: {"color":"#000"},
                  onClick: handleLogout
                }, "退出登录")
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, { style: {"background-color":"#f5f7fb"} }, {
          default: _withCtx(() => [
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_sider, {
                  theme: "light",
                  width: "208px",
                  style: { overflow: 'auto', height: '100vh-60px', marginTop: '56px', position: 'fixed', left: 0, top: 0, bottom: 0 },
                  collapsed: collapsed.value,
                  "onUpdate:collapsed": _cache[7] || (_cache[7] = ($event: any) => ((collapsed).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", {
                        class: _normalizeClass(['menu', 'xn-pointer', { active: isHome.value }]),
                        onClick: goHome
                      }, [
                        _createVNode(_component_xn_icon, {
                          icon: "home",
                          class: "xn-icon"
                        }),
                        _hoisted_32
                      ], 2),
                      _hoisted_33,
                      _hoisted_34
                    ]),
                    _createVNode(_component_a_menu, {
                      ref_key: "menus",
                      ref: menus,
                      mode: "inline",
                      class: "cp-left-menu",
                      openKeys: openKeys.value,
                      "onUpdate:openKeys": _cache[5] || (_cache[5] = ($event: any) => ((openKeys).value = $event)),
                      selectedKeys: selectedKeys.value,
                      "onUpdate:selectedKeys": _cache[6] || (_cache[6] = ($event: any) => ((selectedKeys).value = $event)),
                      onClick: menuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Menus, { list: menuList.value }, null, 8, ["list"])
                      ]),
                      _: 1
                    }, 8, ["openKeys", "selectedKeys"])
                  ]),
                  _: 1
                }, 8, ["collapsed"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_layout, {
              class: "s5-ml",
              style: { marginLeft: '208px' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_router_view)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_xn_modal, {
      width: "600px",
      uid: "configAuto",
      title: "温馨提示",
      closable: false
    }, {
      default: _withCtx(() => [
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_a_button, { onClick: toCancel }, {
            default: _withCtx(() => [
              _createTextVNode("取消配置")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: tohandleConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("开始配置")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_xn_modal, {
      width: "600px",
      uid: "isSubmit",
      title: "温馨提示",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_xn_alert, { type: "warning" }, {
          default: _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_a_button, { onClick: toCancel }, {
            default: _withCtx(() => [
              _createTextVNode("取消配置")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: toConfirms
          }, {
            default: _withCtx(() => [
              _createTextVNode("开始配置")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_xn_modal, {
      width: "450px",
      uid: "configuration",
      title: "主机环境配置中",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_xn_alert, { type: "warning" }, {
          default: _withCtx(() => [
            _hoisted_40,
            _hoisted_41
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_42, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(progressList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "progress-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, _toDisplayString(item.title), 1),
                (item.status === 'success')
                  ? (_openBlock(), _createBlock(_unref(CheckCircleTwoTone), {
                      key: 0,
                      twoToneColor: "#52c41a"
                    }))
                  : _createCommentVNode("", true),
                (item.status === 'exception')
                  ? (_openBlock(), _createBlock(_unref(CloseCircleTwoTone), {
                      key: 1,
                      twoToneColor: "#FF4D4F"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createVNode(_component_a_button, {
            type: "primary",
            class: "next-button",
            disabled: settingShow.value,
            style: {"width":"100%"},
            onClick: toCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 配置完成 ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(contextHolder)),
    _createVNode(_component_a_drawer, {
      title: "任务详情",
      open: open.value,
      onClose: onClose
    }, {
      default: _withCtx(() => [
        _createVNode(Detail, { row: curRow.value }, null, 8, ["row"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})